<template>
  <el-table-column :label="label" :prop="prop" class-name="airport-name" :sortable="sortable" />
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: '空港名'
    },
    prop: {
      type: String,
      default: 'airport_name'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.el-table {
  th,
  td {
    &.airport-name {
      width: 25em;
    }
  }
}
</style>
